import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../../admin/Constant";

export const DestinationApi = createApi({
  reducerPath: "DestinationApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${API_URL}/destinations` }),
  endpoints: (builder) => ({
    addDestination: builder.mutation({
      query: (data) => ({
        url: "create",
        method: "POST",
        body: data,
      }),
    }),
    allDestination: builder.query({
      query: () => ({
        url: "all",
        method: "GET",
      }),
    }),
    getDestinationBySlug: builder.query({
      query: (slug) => ({
        url: `detail/${slug}`,
        method: "GET",
      }),
    }),
    updateDestination: builder.mutation({
      query: ({ slug, data }) => ({
        url: `update/${slug}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteDestination: builder.mutation({
      query: (id) => ({
        url: `delete/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { 
  useAddDestinationMutation, 
  useAllDestinationQuery, 
  useGetDestinationBySlugQuery, 
  useUpdateDestinationMutation, 
  useDeleteDestinationMutation 
} = DestinationApi;
